





























import {Component, Prop, Vue} from "vue-property-decorator";
import {DownlinkItem} from "@/services/CoreClient";
import VueError from "@/components/VueError.vue";
import Loading from "@/components/Loading.vue";
import TimestampAgo from "@/components/TimestampAgo.vue";
import {curGroupService} from "@/services/GroupService";
import {curDeviceService} from "@/services/DeviceService";

@Component({
  components:{
    VueError,
    Loading,
    TimestampAgo
  }
})
export default class DownlinksQueueSection extends Vue {
  @Prop({ default: () => '',  type: String}) deviceId!:string;
  @Prop({ default: () => {}, type: Object}) bus!:Vue;

  downlinks:DownlinkItem[] = [];
  error:string = '';

  async mounted() {
    this.bus.$on('refresh', async () => {
      this.downlinks = await this.loadDownlinksQueue(this.deviceId);
    });
    this.downlinks = await this.loadDownlinksQueue(this.deviceId);
  }

  async loadDownlinksQueue(deviceId:string):Promise<DownlinkItem[]> {
    try {
      return  await curDeviceService.getDownlinksQueue({deviceId}) as DownlinkItem[];
    } catch (err) {
      this.error = (err as Error).message;
      return [];
    }
  }
}
